<div class="filter-chip" mat-ripple (click)="emitClickEvent($event)">
  <ng-content select="mat-icon"></ng-content>
  <span class="title">
    <ng-content select="filter-chip-title"></ng-content>
  </span>
  <span class="value">
    <ng-content select="filter-chip-value"></ng-content>
  </span>
  <button class="filter-chip-action" mat-icon-button mat-inline *ngIf="!!canRemove" (click)="emitDeleteEvent($event)">
    <mat-icon matSuffix>cancel</mat-icon>
  </button>
  <button class="filter-chip-action" mat-icon-button *ngIf="!canRemove">
    <mat-icon>edit</mat-icon>
  </button>
</div>
